<template>
  <div class="app-root">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.app-root {
  width: 100%;
  height: 100%;
}
ul li {
  list-style: none;
}
/* 滚动条隐藏 */
/* ::-webkit-scrollbar {
  width: 0;
} */

/* 针对垂直滚动条 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条的宽度 */
}

/* 针对水平滚动条 */
::-webkit-scrollbar {
  height: 6px; /* 滚动条的高度 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: #c3c8d1; /* 滑块颜色 */
  border-radius: 999px; /* 滑块圆角 */
}
::-webkit-scrollbar-thumb:hover {
  background-color: #9fa6b2;
}
::-webkit-scrollbar-track {
  background: transparent;
}
.ml10 {
  margin-left: 10px;
}
.mr10 {
  margin-right: 10px;
}
</style>
